import React from 'react'
import './mentees.css'
import Modal from "../../components/Modal"
import "animate.css/animate.min.css"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import ContentPage from "../../components/content-page"
import Meta from "../../components/meta"
import mentConstant from '../../constant/mentConstant'

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal direction="" className="teamdetails__wrapper" show={show} onHide={onHide}>
      <Modal.Header>
            <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
                    <div className="item_des">{activeItem.post}</div>
                    <div className="item_des">{activeItem.company}</div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
               
              
        <div className="item__desc force-overflow">
          <div className="item__desc_scr" style={{ padding:"0px 10px 0px 0px"}} dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
               
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  )
}

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
}

export class Index extends React.Component{
    constructor (args) {
    super(args)
    this.state = {
      activeItem: {},
      isShow: false
    }
    
  }

  
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {}
    })
  }


    render(){
        const { location } = this.props
        const { isShow } = this.state
        return(
            <ContentPage>
            <Meta title="Winpe ProClub Mentorship Program | Mentees: Cohort of 2020" description="A group of highly talented young women on their path to continued success." image={"https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg"} location={location} />
                <div className="mentees-wrapper" >
               <div className="container">
               <div className="heading"><h1>Mentees <br /><span> </span> Cohort I</h1></div>
               <div className="section_intro_text">A group of highly talented young women on their path to continued success.</div>
                   <div className="row">
                   {mentConstant.map((item, i) => {
                    return (
                       <div className="col-sm-6 col-md-3">
                        
                          <div className="circle-card">
                                <div className="card-inner">
                                <img className="imagess" src={item.imgUrl} />
                                <div className="overlayy">
                                &nbsp;
                                </div>
                                <div className="cercle">
                                &nbsp;
                                </div>
                                {/*<span className="pop-up"><i className="fa fa-long-arrow-right" /></span>*/}
                                <div className="text">
                                <h3 className="circle-name">{item.name} </h3>
                                    <p className="post"><b>Previous Profile</b></p>
                                    <p className="post">{item.oldpost} </p>
                                    <p className="post">{item.oldcompany} </p>
                                    <hr/>
                                    <p className="post"><b>Current Profile</b></p>
                                    <p className="post">{item.newpost} </p>
                                    <p className="post">{item.newcompany} </p>
                                     <a target="_blank" href={item.linkedIn} className="linkedinbtn btn btn-primary btn-sm" ><i className="fa fa-linkedin"></i></a>
                                </div>
                                </div>
                          </div>
                       </div>
                       )
                    })}
                   </div>
               </div>
               <TeamModal show={isShow} onHide={this.togglePopUp} activeItem={this.state.activeItem} />
            </div>
        </ContentPage>
        )
    }
}
Index.propTypes = {
  location: PropTypes.object
}

export default Index



// WEBPACK FOOTER //
// ./src/pages/winpementees/index.js